export default (callback) => {
  const apiKey = 'AIzaSyAP0SnrBpNSbGtw7i_ybKz0QIG_Fr4sUoU';
  const script = document.createElement('script');

  script.async = true;
  script.defer = true;
  script.src = `https://maps.googleapis.com/maps/api/js?key=${apiKey}&callback=initMapCallback&loading=async`;
  document.head.appendChild(script);

  window.initMapCallback = callback.bind(window);
}
